module.exports = __webpack_public_path__ + "static/media/not-search-power.be65c62c.png";